import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// utils
import { Translations } from '../../../utils';
// restClient
import { aemHostClient } from '../../../restClient';
// children
import NavigationList from '../../common/NavigationList/';
//action Creator
import { deleteProduct } from '../actions/actionCreator';
import { setDarkTitleBarContent } from '../../layouts/actions/actionCreator';
//style
import './AddGLSproduct.css';

const AddGLSproduct = (props) => {
  const [pageJson, setPageJson] = useState();
  const [options, setOptions] = useState();

  const translations = (text) => {
    return Translations(text, props.lang.currentLang.lang, props.lang.translatedData)
  }

  useEffect(() => {
    (async () => {
      const { data } = await aemHostClient("/aemData/formData/json_gls");
      if (data.par) {
        document.title = `${translations(data.par.page_title_mainTitle.pageHeading)} - ${'HSBC GLCM'}`;

        (async () => {
          const { data } = await aemHostClient("/aemData/formData/json_add-gls");
          setOptions(data.par.page_title_mainTitle.options)
        })();
      }
      setPageJson(data)
      //  const {title, actionBtnText} = pageJson.par.dark_title_bar;
      //  props.setDarkTitleBarContent(title, true, actionBtnText, undefined, undefined);
      props.updateBreadCrumbsState(4);
    })();

    (async () => {
      const { data } = await aemHostClient("/aemData/formData/json_dark-title-bar");
      props.setDarkTitleBarContent(Translations(data.par.static_text_darkTitleBar.createCase, props.lang.currentLang.lang, props.lang.translatedData), true, Translations(data.par.static_text_darkTitleBar.caseList, props.lang.currentLang.lang, props.lang.translatedData), undefined, undefined);
    })();
  }, []);

  const topreviouspage = () => {
    props.history.push("/create-a-case/add-echannel")
  }
  const formpage = () => {
    props.history.push("/create-a-case/create-new-glsproduct");
  }
  const finish = () => {
    props.history.push('/case-body')
  }


  let jsx = (<h3>Loading...</h3>);
  if (pageJson) {
    const { page_title_mainTitle, button_addGLSProduct, modal_deleteGlsModal, button_previousEchannels, button_finish } = pageJson.par;
    jsx = (<div className="selectcustomercontainer">
      <h2>{translations(page_title_mainTitle.pageHeading)}</h2>
      <div className="row accountcontainer">
        <div className="col-lg-8 leftcontent">
          <p>{translations(page_title_mainTitle.descriptionText)}</p>
        </div>
        <div className="col-lg-4 rgtcontt">
          <button
            className="btn btn-primary btnaddwrapper"
            id="addNewGlsprod"
            onClick={formpage}
          >
            <span className="icon icon-add addicon"></span>
            {translations(button_addGLSProduct.text)}
          </button>
        </div>
      </div>
      <NavigationList
        cases={props.cases}
        options={translations(options)}
        deleteProduct={props.deleteProduct}
        history={props.history}
        listtype="GLSproducts"
        deleteModalContent={modal_deleteGlsModal || {}}
        pageReferer={'glsPage'}
      />
      <div id="btnwrapperid" className={Object.keys(props.cases).length === 0 ? 'btnWrapper addaccountbtn' : 'btnWrapper setbtnpadd'}>
        <div className="leftbtn">
          <button
            onClick={topreviouspage}
            id="disabledpreviousbtn"
            style={{ paddingTop: '10px' }}
            className={Object.keys(props.cases).length === 0 ? 'btn btn-primary btndisable btnpmg' : 'btn btn-primary btnpmg'}
          >
            <b>{translations(button_previousEchannels.textPrevious)}: </b>{translations(button_previousEchannels.text)}
          </button>
        </div>
        <div className="rightbtn">
          <button id="disabledFinsh" onClick={finish} className='btn btn-primary btnbg'>
            {translations(button_finish.text)}
          </button>
        </div>
      </div>
    </div>);
  }
  return (
    <div>
      {jsx}
    </div>
  );

}


const mapStateToProps = state => {
  return {
    cases: state.cases,
    lang: state.lang
  }
}

const mapDispatchToProps = dispatch => {
  return {
    deleteProduct: (caseId, productType, productId) => {
      dispatch(deleteProduct(caseId, productType, productId))
    },
    setDarkTitleBarContent: (...args) => {
      dispatch(setDarkTitleBarContent(...args))
    }
  }
}

AddGLSproduct.propTypes = {
  cases: PropTypes.object,
  lang: PropTypes.object,
  history: PropTypes.object
};

export default connect(mapStateToProps, mapDispatchToProps)(AddGLSproduct);



// WEBPACK FOOTER //
// ./src/components/createAcase/AddGLSproduct/index.js